import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		// Small delay to ensure the route change has completed
		const timer = setTimeout(() => {
			// Find the main scrollable container with overflow-y-scroll
			const mainElement = document.querySelector('main[class*="overflow-y-scroll"]');
			
			if (mainElement) {
				// Smooth scroll the main container to top
				mainElement.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}, 100); // Slightly longer delay to ensure DOM is ready

		return () => clearTimeout(timer);
	}, [pathname]);

	return null;
}